import type { FloatLabelType } from '@angular/material/form-field';
import {
  MUNILY_FILTER_FIELD_DEFAULT_FLOAT_LABEL,
  MUNILY_FILTER_FIELD_DEFAULT_SIZE,
  MunilyFilterFieldSize,
} from '../filter-fields/filter-field.types';
import { MunilyTextFieldWidthLayout } from '../text-field/text-field.types';

/** Valores por defecto del contrato público (alineado al DS / playground). */
export const MUNILY_FILTER_SELECT_FIELD_DEFAULTS: {
  size: MunilyFilterFieldSize;
  widthLayout: MunilyTextFieldWidthLayout;
  panelClass: string;
  clearAriaLabel: string;
  clearable: boolean;
  disableOptionCentering: boolean;
  floatLabel: FloatLabelType;
} = {
  size: MUNILY_FILTER_FIELD_DEFAULT_SIZE,
  widthLayout: 'ds',
  panelClass: 'munily-filter-select-panel',
  clearAriaLabel: 'Limpiar selección',
  clearable: true,
  disableOptionCentering: true,
  floatLabel: MUNILY_FILTER_FIELD_DEFAULT_FLOAT_LABEL,
};
